module.exports = __webpack_public_path__ + "img/sf.3d5dd2e1.png";